import React from 'react';

import 'styles/common/confirmation-modal.scss';

const AddEditNewModal = ({ changeInput, disabledSave, inputVal, label, modalTitle, onCancel, onSave }) => (
  <div data-bem="AddEditNewModal">
    <div className="overlay" />
    <div className="confirmation-modal animated zoomIn">
      <div className="modal-body">
        <h2 className="modal-title"> {modalTitle}</h2>
        <div className="modal-content">
          <div className="text-field-container">
            <span>{label}:</span>
            <input className="input-default" value={inputVal} onChange={() => void changeInput()} />
          </div>
        </div>
        <div className="modal-footer-new">
          <button className="btn btn-violet-link" onClick={onCancel}>
            Cancel
          </button>
          <button className="btn btn-violet" disabled={disabledSave} onClick={onSave}>
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default AddEditNewModal;
